import React, { useEffect, useRef } from 'react';

import AddIcon from '@mui/icons-material/Add';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import BoltIcon from '@mui/icons-material/Bolt';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import { Box, Dialog, DialogTitle, IconButton, InputAdornment, Menu, MenuItem, TextField, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import mime from 'mime';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from "styled-components";
import { v4 as uuidv4 } from 'uuid';
import AiSuggestionTrigger from '../../../../components/ai-suggestion-trigger';
import EmojiPicker from '../../../../components/emoji-picker';
import * as componentActions from '../../../../redux/actions/chats'; // trocar pelo redux que criarei no chat
import { recordOutcome as recordAiSuggestionOutcomeRequest, invalidateContext as invalidateAiSuggestionContextRequest } from '../../../../services/aisuggestion.service';
import { Styles } from '../../../../styles/material-styles';
import { PapiroConsole } from '../../../../utils/papiroConsole';
import ChatQuickResponse from './chat-quick-response';
import QuickResponseModal from './quick-response-modal';
import './styles.css';
import AudioRecorder from './audio/audio-recorder';
import AudioMessage from './audio/audio-message';
import { getSpellCheckLang } from '../../../../helpers/spellcheck';

const ENTER_NEWLINE_STORAGE_KEY = 'mexx2do-enter-newline-preference';

function readEnterNewlinePreference() {
  try {
    return window.localStorage.getItem(ENTER_NEWLINE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }
  & .MuiOutlinedInput-notchedOutline legend {
    display: none;
  }
  & .MuiOutlinedInput-notchedOutline:hover {
    border: none;
  }
  & .MuiInputLabel-root {
    color: #FFF;
  }
  & .MuiOutlinedInput-input {
    padding: 7.5px 10px;
    color: #FFF;
  }
  & .MuiOutlinedInput-root {
    background-color: #3F51B4;
    border: none;
    border-radius: 20px;
  }
  & .MuiOutlinedInput-root .Mui-focused {
    border: none;
  }
  & .MuiInputBase-colorPrimary {
    border: none;
  }
`;

function ChatSendBar(props) {
  const { userSession, sendMessage, sendMessageAttachment,sendMessageAudio, setExecScrollToBottom, intl } = props
  const fileInputRef = useRef(null);
  const chatReady = props.chats && props.chats.chat && props.chats.chat.id;



  const [openModalQuickResponse, setOpenModalQuickResponse] = useState(false);
  const [currentQuickResponseSeledted, setCurrentQuickResponseSeledted] = useState(null);


  const [message, setMessage] = useState('')

  const [enterNewlinePreference, setEnterNewlinePreferenceState] = useState(readEnterNewlinePreference);

  const setEnterNewlinePreference = (value) => {
    try {
      window.localStorage.setItem(ENTER_NEWLINE_STORAGE_KEY, String(value));
    } catch {
    }
    setEnterNewlinePreferenceState(value);
  };

  const toggleEnterNewlinePreference = () => {
    setEnterNewlinePreference(!enterNewlinePreference);
  };


  /* MENU MORE ACTIONS START */
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenuMoreActions = Boolean(anchorEl);

  const handleClickMenuMoreActions = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenuMoreActions = () => {
    setAnchorEl(null);
  };


  const handleClickMenuItemQuickResponse = () => {
    handleCloseMenuMoreActions();
    setOpenModalQuickResponse(true);
  }

  const handleAttachMenuItemClick = () => {
    handleCloseMenuMoreActions();
    fileInputRef.current?.click();
  };
  /* MENU MORE ACTIONS END */

  /* AI SUGGESTION START */
  const aiSuggestionMessageCountSnapshotRef = useRef(null);
  const [aiSuggestionOutdated, setAiSuggestionOutdated] = useState(false);
  const aiSuggestionUsedRef = useRef(null);
  const [aiSuggestionOpen, setAiSuggestionOpen] = useState(false);
  const [aiSuggestionAnchorEl, setAiSuggestionAnchorEl] = useState(null);
  const [aiSuggestionAvailable, setAiSuggestionAvailable] = useState(false);
  const [aiSuggestionChecking, setAiSuggestionChecking] = useState(true);

  const handleAiSuggestionAvailabilityChange = ({ available, checking }) => {
    setAiSuggestionAvailable(available);
    setAiSuggestionChecking(checking);
  };

  const handleClickMenuItemAiSuggestion = () => {
    setAiSuggestionAnchorEl(anchorEl);
    handleCloseMenuMoreActions();
    setAiSuggestionOpen(true);
  };

  const handleCloseAiSuggestion = () => {
    setAiSuggestionOpen(false);
  };

  const getChatMessageCount = () => {
    const chat = props.chats && props.chats.chat;
    if (!chat || !chat.id) return 0;
    const chatV2 = props.chats.chatsv2 && props.chats.chatsv2[chat.id];
    const itens = chatV2 && chatV2.itens ? chatV2.itens : null;
    return itens ? Object.keys(itens).length : 0;
  }

  useEffect(() => {
    if (aiSuggestionMessageCountSnapshotRef.current === null) return;

    const currentCount = getChatMessageCount();
    if (currentCount !== aiSuggestionMessageCountSnapshotRef.current) {
      setAiSuggestionOutdated(true);
    }
  }, [props.chats])

  const handleAiSuggestionRegenerated = () => {
    aiSuggestionMessageCountSnapshotRef.current = getChatMessageCount();
    setAiSuggestionOutdated(false);
  }

  const recordAiSuggestionOutcome = async (suggestion, outcome, finalContent = null) => {
    if (!suggestion) return
    try {
      const payload = {
        suggestionId: suggestion.id,
        outcome
      };
      if (finalContent != null) {
        payload.finalContent = finalContent;
      }
      await recordAiSuggestionOutcomeRequest(payload);
    } catch (e) {
      PapiroConsole.log("=== recordAiSuggestionOutcome -> error ===");
      PapiroConsole.log(e);
    }
  }

  const invalidateAiSuggestionContext = async (chatId) => {
    if (!chatId) return;
    try {
      await invalidateAiSuggestionContextRequest({ calledId: null, chatId });
    } catch (e) {
      PapiroConsole.log("=== invalidateAiSuggestionContext -> error ===");
      PapiroConsole.log(e);
    }
  }

  const handleUseAiSuggestion = (suggestion) => {
    if (!suggestion) return
    setMessage(suggestion.content || '');
    aiSuggestionUsedRef.current = suggestion;
  }

  const handleCopyAiSuggestion = (suggestion) => {
    if (!suggestion) return
    aiSuggestionUsedRef.current = suggestion;
  }
  /* AI SUGGESTION END */

  const handleChangeText = (e) => {
    const { name, value } = e.target;
    setMessage(value)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (enterNewlinePreference) {
        return;
      }
      sendInternalMessage(event);
    } else if (event.ctrlKey && event.code === 'Space') {
      event.preventDefault();
      setOpenModalQuickResponse(true);
    }
  }

  const handleEmojiClick = (emojiObject) => {
    setMessage((prevMensagem) => prevMensagem + emojiObject.emoji);
  }

  const sendAttachments = async (event) => {
    PapiroConsole.log("entrei aqui 23")
    event.preventDefault()
    
    const files = event.target.files;
    var arrayAttachments = [...files];
    PapiroConsole.log(files)
    PapiroConsole.log(arrayAttachments)
    PapiroConsole.log("entrada aqui")
    var guidList = [];

    if (files.length > 0) {
      let chat = props.chats.chat;
      var chatid = null;
      //alert(JSON.stringify(chat))
      if ((props.phonenumberid && props.phonenumberid.phonenumberid > 0) || (chat && chat.customerid && chat.customerid > 0)) {
        //alert(JSON.stringify(props.phonenumberid))
        //console.error(JSON.stringify(props.phonenumberid));
        //return false;
        if ((props.customerid && props.customerid > 0) || (props.customerid.id > 0) || (chat && chat.customerid && chat.customerid > 0)) {
          
          //alert(guid);
          //return;
          
          
          var msg = {
            //content: message,
            //guid: guid,
            to: props.customerid,
            userid: userSession.user.id,
            createdat: moment().format('YYYY/MM/DD HH:mm:ss'),
            createtime: moment().format('HH:mm'),
            icon: 'request',
            channelid: { id: props.phonenumberid.channelid },
            techinicalteamid: { id: props.phonenumberid.techinicalteamid },
            originrequestid: props.phonenumberid.originrequestid,

          };
          if (props.customerid.id > 0) {
            msg.to = props.customerid.phone;
            if (props.phonenumberid?.messageproviderid === 2 && props.customerid.bsuid) msg.recipientbsuid = props.customerid.bsuid;
            msg.customerid = props.customerid.id;
          }
          if (chat && chat.customerid && chat.customerid > 0) {
            chatid = chat.id;
            msg.channelid = { id: chat.channelid };
            msg.techinicalteamid = { id: chat.techinicalteamid };
            msg.to = chat.customer.phone;
            if (chat.messageproviderid === 2 && (chat.customer?.bsuid || chat.senderbsuid)) msg.recipientbsuid = chat.customer?.bsuid || chat.senderbsuid;
            msg.messageproviderid = chat.messageproviderid;
            msg.messageproviderconfigid = chat.messageproviderconfigid;
            msg.customerid = chat.customerid;
            msg.originrequestid = chat.originrequestid;
            msg.phonenumberid = {
              id: chat.registrationnumberrequestid
              , messageproviderid: chat.messageproviderid
              , messageproviderconfigid: chat.messageproviderconfigid
              , organizationid: chat.organizationid
              , organizationname: chat.organizationname
              , requeststatusid: chat.chatstatusid
              , originrequestid: chat.originrequestid
            };
          }
          PapiroConsole.log(chat)
          PapiroConsole.log("chat para capturar customer aqui")

          var error = false;
          var errorMessage = "";
          // alert(JSON.stringify(msg));
          arrayAttachments.forEach(element => {

            let guid = uuidv4();

            PapiroConsole.log(element)
            PapiroConsole.log("element aqui")
            if (chat && chat.chatmessages) {

              var attachmentType = getAttachmentType(element);
              if(attachmentType == "unknown"){
                error = true;
                errorMessage = `Arquivo ${element.name} não é suportado pelo sistema`;

              }
              var m = {
                channelid: msg.channelid.id,
                chatid: chatid,
                content: element.name,
                createdat: msg.createdat,
                delivered: false,
                read: false,
                request: true,
                senderuserid: msg.userid,
                sent: false,
                guid: guid,
                sendername: userSession.user.name,
                messagetype : attachmentType,
                messageorigin : 1
  
              };

              chat.chatmessages.push(m)
              guidList.push(guid)
              
            }
            
          });
          
          if(!error){
            PapiroConsole.log(chat.chatmessages)
            PapiroConsole.log("chat.chatmessages")
            await props.addCurrentChat(chat)
            
          }

          setMessage('');
          sendMessageAttachment(msg, chatid, arrayAttachments, guidList, error,errorMessage );
        }
        else {
          props.setNotificationMessage("Selecione a destinatário da mensagem.");
          props.setNotificationVariant("info");
          props.setOpenNotification(true);
        }
      }
      else {
        props.setNotificationMessage("Selecione a origem da conversa.");
        props.setNotificationVariant("info");
        props.setOpenNotification(true);
      }
    }

    fileInputRef.current.value = null;
    event.target.files = null;

    
    
  }



  const getAttachmentType = (file) => {
    const mimeType = mime.getType(file.name);
  
    if (mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg' ||
        mimeType === 'image/png' ||
        mimeType === 'image/gif' ||
        mimeType === 'image/webp') {
      return 'image';
    } else if (mimeType === 'video/mp4' ||
               mimeType === 'video/3gpp') {
      return 'video';
    } else if (mimeType === 'application/pdf' ||
               mimeType === 'application/msword' ||
               mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
               mimeType === 'application/vnd.ms-excel' ||
               mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      return 'document';
    } else {
      return 'unknown';
    }
  };

  const sendInternalMessage = async e => {
    e.preventDefault()
    PapiroConsole.log("=== sendInternalMessage ===")
    if (message.length > 0) {
      //alert(JSON.stringify(props.phonenumberid));
      let chat = props.chats.chat;
      var chatid = null;
      //alert(JSON.stringify(chat))
      if ((props.phonenumberid && props.phonenumberid.phonenumberid > 0) || (chat && chat.customerid && chat.customerid > 0)) {
        //alert(JSON.stringify(props.phonenumberid))
        //console.error(JSON.stringify(props.phonenumberid));
        //return false;
        if ((props.customerid && props.customerid > 0) || (props.customerid.id > 0) || (chat && chat.customerid && chat.customerid > 0)) {
          let guid = uuidv4();
          //alert(guid);
          //return;
          var msg = {
            content: message,
            guid: guid,
            to: props.customerid,
            userid: userSession.user.id,
            createdat: moment().format('YYYY/MM/DD HH:mm:ss'),
            createtime: moment().format('HH:mm'),
            icon: 'request',
            channelid: { id: props.phonenumberid.channelid },
            techinicalteamid: { id: props.phonenumberid.techinicalteamid },
            originrequestid: props.phonenumberid.originrequestid,

          };
          if (props.customerid.id > 0) {
            msg.to = props.customerid.phone;
            if (props.phonenumberid?.messageproviderid === 2 && props.customerid.bsuid) msg.recipientbsuid = props.customerid.bsuid;
            msg.customerid = props.customerid.id;
          }
          if (chat && chat.customerid && chat.customerid > 0) {
            chatid = chat.id;
            msg.channelid = { id: chat.channelid };
            msg.techinicalteamid = { id: chat.techinicalteamid };
            msg.to = chat.customer.phone;
            if (chat.messageproviderid === 2 && (chat.customer?.bsuid || chat.senderbsuid)) msg.recipientbsuid = chat.customer?.bsuid || chat.senderbsuid;
            msg.messageproviderid = chat.messageproviderid;
            msg.messageproviderconfigid = chat.messageproviderconfigid;
            msg.customerid = chat.customerid;
            msg.originrequestid = chat.originrequestid;
            msg.phonenumberid = {
              id: chat.registrationnumberrequestid
              , messageproviderid: chat.messageproviderid
              , messageproviderconfigid: chat.messageproviderconfigid
              , organizationid: chat.organizationid
              , organizationname: chat.organizationname
              , requeststatusid: chat.chatstatusid
              , originrequestid: chat.originrequestid
            };
          }
          // alert(JSON.stringify(msg));
          if (chat && chat.chatmessages) {
            var m = {
              channelid: msg.channelid.id,
              chatid: chatid,
              content: msg.content,
              createdat: msg.createdat,
              delivered: false,
              read: false,
              request: true,
              senderuserid: msg.userid,
              sent: false,
              guid: guid,
              sendername: userSession.user.name,
              messageorigin : 1

            };
            chat.chatmessages.push(m)
            await props.addCurrentChat(chat)
          }

          setMessage('');
          sendMessage(msg, chatid);

          if (aiSuggestionUsedRef.current) {
            const usedSuggestion = aiSuggestionUsedRef.current;
            aiSuggestionUsedRef.current = null;
            recordAiSuggestionOutcome(usedSuggestion, 'accepted', msg.content);
          }

          invalidateAiSuggestionContext(chatid);
        }
        else {
          props.setNotificationMessage("Selecione a destinatário da mensagem.");
          props.setNotificationVariant("info");
          props.setOpenNotification(true);
        }
      }
      else {
        props.setNotificationMessage("Selecione a origem da conversa.");
        props.setNotificationVariant("info");
        props.setOpenNotification(true);
      }
    }
  }

  const closeModalQuickResponse = () => {
    setCurrentQuickResponseSeledted(null);
    setOpenModalQuickResponse(false);
  }
  const handleSendAudio = async (audioData) => {

     let chat = props.chats.chat;
     var chatid = null;
      //alert(JSON.stringify(chat))
     if ((props.phonenumberid && props.phonenumberid.phonenumberid > 0) || (chat && chat.customerid && chat.customerid > 0)) {
        //alert(JSON.stringify(props.phonenumberid))
        //console.error(JSON.stringify(props.phonenumberid));
        //return false;
        if ((props.customerid && props.customerid > 0) || (props.customerid.id > 0) || (chat && chat.customerid && chat.customerid > 0)) {
          let guid = uuidv4();
          //alert(guid);
          //return;
          var msg = {
            //contentAudio : <AudioMessage
            //key={guid}
            //audioData={audioData.audioData}
            //mimeType={audioData.mimeType}
            //duration={audioData.duration}
            //senderName={userSession.user.name}
            //timestamp={moment().format('YYYY/MM/DD HH:mm:ss')}
            //isOwnMessage={true}
            ///>,
            content:audioData.audioData,
            name: '',
            guid: guid,
            to: props.customerid,
            userid: userSession.user.id,
            createdat: moment().format('YYYY/MM/DD HH:mm:ss'),
            createtime: moment().format('HH:mm'),
            icon: 'request',
            channelid: { id: props.phonenumberid.channelid },
            techinicalteamid: { id: props.phonenumberid.techinicalteamid },
            originrequestid: props.phonenumberid.originrequestid,

          };
          if (props.customerid.id > 0) {
            msg.to = props.customerid.phone;
            if (props.phonenumberid?.messageproviderid === 2 && props.customerid.bsuid) msg.recipientbsuid = props.customerid.bsuid;
            msg.customerid = props.customerid.id;
          }
          if (chat && chat.customerid && chat.customerid > 0) {
            chatid = chat.id;
            msg.channelid = { id: chat.channelid };
            msg.techinicalteamid = { id: chat.techinicalteamid };
            msg.to = chat.customer.phone;
            if (chat.messageproviderid === 2 && (chat.customer?.bsuid || chat.senderbsuid)) msg.recipientbsuid = chat.customer?.bsuid || chat.senderbsuid;
            msg.messageproviderid = chat.messageproviderid;
            msg.messageproviderconfigid = chat.messageproviderconfigid;
            msg.customerid = chat.customerid;
            msg.originrequestid = chat.originrequestid;
            msg.phonenumberid = {
              id: chat.registrationnumberrequestid
              , messageproviderid: chat.messageproviderid
              , messageproviderconfigid: chat.messageproviderconfigid
              , organizationid: chat.organizationid
              , organizationname: chat.organizationname
              , requeststatusid: chat.chatstatusid
              , originrequestid: chat.originrequestid
            };
          }
          // alert(JSON.stringify(msg));
          if (chat && chat.chatmessages) {
            const soundName = `audio_${msg?.to || msg?.recipientbsuid}_${Date.now()}.ogg`;
            msg.name = soundName;
            var m = {
              channelid: msg.channelid.id,
              chatid: chatid,
              content: soundName,
              createdat: msg.createdat,
              delivered: false,
              read: false,
              request: true,
              senderuserid: msg.userid,
              sent: false,
              guid: guid,
              sendername: userSession.user.name,
              messageorigin : 1,
              messagetype : "audio",
  
            };
            chat.chatmessages.push(m)
            await props.addCurrentChat(chat)
          }
          //var arrayAttachments = [audioData];
          //var guidList = [];
          //guidList.push(guid);
          setMessage('');
          //sendMessage(msg, chatid);
          //sendMessageAttachment(msg, chatid, arrayAttachments, guidList, "","" );

          sendMessageAudio(msg, chatid, audioData);
          try {
            /*
            await audioService.sendAudioMessage({
              senderId: userSession.user.id,
              senderName: userSession.user.name,
              recipientId: msg.to,
              audioData: audioData.audioData,
              mimeType: audioData.mimeType,
              duration: audioData.duration
            });
            */
          } catch (error) {
            console.error('Erro ao enviar áudio:', error);
            // Tratar erro (mostrar notificação, etc)
          }



        }
        else {
          props.setNotificationMessage("Selecione a destinatário da mensagem.");
          props.setNotificationVariant("info");
          props.setOpenNotification(true);
        }
      }
      else {
        props.setNotificationMessage("Selecione a origem da conversa.");
        props.setNotificationVariant("info");
        props.setOpenNotification(true);
      }    

  };

  return (<div className="omnichannel-chat-message">
    <ChatQuickResponse
      setMessage={setMessage}
      customerid={props.customerid} 
      phonenumberid={props.phonenumberid} 
      sendMessage={props.sendMessage} 
      setExecScrollToBottom={setExecScrollToBottom}
      onSetCurrentQuickResponseSeledted={setCurrentQuickResponseSeledted}
      onSetOpenModal={setOpenModalQuickResponse}
    />
    {chatReady && (
      <Box className="omnichannel-chat-send-bar-row">
        <Box className="omnichannel-chat-send-bar-input">
          <StyledTextField
          disabled={props.chats.chat && props.chats.chat.chatstatusid == 1 || props.chats.chat.chatstatusid == 2 ? false : true}
          fullWidth
          multiline
          maxRows={5}
          label=""
          inputProps={{
            maxLength: 2000,
            list: "quickResponses",
            spellCheck: true,
            lang: getSpellCheckLang(intl.locale)
          }}
          autoComplete='off'
          variant='outlined'
          name='searchChat'
          placeholder="Mensagem, Pressione Ctrl + Espaço para adicionar uma resposta rápida."
          onChange={handleChangeText}
          onKeyDown={handleKeyDown}
          value={message}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                <EmojiPicker
                  onEmojiClick={handleEmojiClick}
                  button={<SentimentSatisfiedAltIcon sx={{ color: '#FFF' }} />}
                />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end" sx={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                <>
                  <Tooltip title="Mais ações">
                    <IconButton
                      onClick={handleClickMenuMoreActions}
                      size="small"
                      aria-controls={openMenuMoreActions ? 'account-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openMenuMoreActions ? 'true' : undefined}
                      variant="contained"
                      sx={{
                        transition: "transform 0.3s ease-in-out",
                        transform: openMenuMoreActions ? "rotate(45deg)" : "rotate(0deg)",
                      }}
                    >
                      <AddIcon sx={{ color: '#FFF' }}/>
                    </IconButton>
                  </Tooltip>


                  <Menu
                    anchorEl={anchorEl}
                    open={openMenuMoreActions}
                    onClose={handleCloseMenuMoreActions}
                    disableScrollLock
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      onClick={handleClickMenuItemQuickResponse}
                      style={{display: 'flex', alignItems: 'center', gap: '4px'}}
                    >
                      <BoltIcon sx={{ color: '#FFD700' }}/>
                      <span>Mensagens Rápidas</span>
                    </MenuItem>
                    <MenuItem
                      onClick={handleClickMenuItemAiSuggestion}
                      disabled={aiSuggestionChecking || !aiSuggestionAvailable}
                      style={{display: 'flex', alignItems: 'center', gap: '4px'}}
                    >
                      <SmartToyOutlinedIcon sx={{ color: '#2196F3' }}/>
                      <span>{intl.formatMessage({ id: 'ai.suggestion.action.label' })}</span>
                    </MenuItem>
                    <MenuItem
                      onClick={handleAttachMenuItemClick}
                      style={{display: 'flex', alignItems: 'center', gap: '4px'}}
                    >
                      <AttachFileIcon fontSize="small" />
                      <span>{intl.formatMessage({ id: 'omnichannel.chat.menu.attach' })}</span>
                    </MenuItem>
                    <MenuItem
                      onClick={toggleEnterNewlinePreference}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        ...(enterNewlinePreference && {
                          backgroundColor: 'var(--mexx-green-subtle, #e9edf8)',
                          color: 'var(--mexx-green-primary, #8BC34A)',
                        }),
                      }}
                    >
                      <KeyboardReturnIcon
                        fontSize="small"
                        sx={{ color: enterNewlinePreference ? 'var(--mexx-green-primary, #8BC34A)' : undefined }}
                      />
                      <span>{intl.formatMessage({ id: 'omnichannel.chat.menu.enter.newline' })}</span>
                      {enterNewlinePreference && (
                        <CheckIcon
                          fontSize="small"
                          sx={{ color: 'var(--mexx-green-primary, #8BC34A)', marginLeft: 'auto' }}
                        />
                      )}
                    </MenuItem>
                  </Menu>
                  <input
                    ref={fileInputRef}
                    id="attachment-input"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={sendAttachments}
                    multiple
                  />
                </>

                <AiSuggestionTrigger
                  calledId={null}
                  chatId={props.chats && props.chats.chat ? props.chats.chat.id : null}
                  onUseSuggestion={handleUseAiSuggestion}
                  onCopySuggestion={handleCopyAiSuggestion}
                  outdated={aiSuggestionOutdated}
                  onRegenerate={handleAiSuggestionRegenerated}
                  hideTrigger
                  open={aiSuggestionOpen}
                  anchorEl={aiSuggestionAnchorEl}
                  onClose={handleCloseAiSuggestion}
                  onAvailabilityChange={handleAiSuggestionAvailabilityChange}
                />
              </InputAdornment>
            ),
          }} />
          
        </Box>
        
        <Box className="omnichannel-chat-send-bar-actions">
          <AudioRecorder
            onSendAudio={handleSendAudio}
            maxDuration={120}
          />

          <IconButton aria-label="Enviar mensagem" onClick={sendInternalMessage} sx={{ flex: '0 0 40px', width: 40, height: 40 }}>
            <SendOutlinedIcon sx={{ color: 'var(--mexx-green-primary, #8BC34A)' }} />
          </IconButton>
        </Box>
      </Box>
    )}

    <Dialog 
      open={openModalQuickResponse} 
      onClose={closeModalQuickResponse} 
      aria-labelledby="form-dialog-title"  
      fullWidth
      maxWidth="lg" 
      PaperProps={{
          // minHeight era `400px` fixo, estourava mobile landscape (~360px de altura).
          // `min(400px, 80vh)` mantém os 400px confortáveis no desktop e em mobile
          // portrait, mas evita a dialog ficar maior que a viewport em landscape.
          style: { width: "100%", maxWidth: "900px", minHeight: 'min(400px, 80vh)' }
      }}
    >
      <DialogTitle id="form-dialog-title">
          {currentQuickResponseSeledted?.title ?? "Respostas rápidas"}
          <ClearIcon 
              onClick={closeModalQuickResponse} 
              style={{ float: 'right', cursor : 'pointer'}}
          /> 
      </DialogTitle>
      <Box>
          <div style={{width: '100%', padding: '24px'}}>
              <QuickResponseModal
                quickResponse={currentQuickResponseSeledted}
                onSentMessage={setMessage}
                onSetOpenModal={setOpenModalQuickResponse}
                onSetCurrentQuickResponseSeledted={setCurrentQuickResponseSeledted}
                customerid={props.customerid} 
                phonenumberid={props.phonenumberid} 
                onSendMessage={props.sendMessage} 
                onSendMessageAttachment={sendMessageAttachment}
                onGetAttachmentType={getAttachmentType}
              />
          </div>
      </Box>     
  </Dialog>
  </div>)
}

ChatSendBar.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chats: state.chats,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ChatSendBar)))
